import { initials } from '@/utils/format';
import { cx } from '@/utils/cx';
import styles from '@/styles/components/Avatar/style.scss';

export function Avatar({ name, tone = 'neutral', size = 'md' }: { name: string; tone?: 'neutral' | 'green'; size?: 'sm' | 'md' }) {
  return (
    <span className={cx(styles.avatar, styles[tone], size === 'sm' && styles.sm)} aria-hidden>
      {initials(name)}
    </span>
  );
}
